// extracted by mini-css-extract-plugin
export default {"commentText":"Comment_commentText__cbLIA","commentInfo":"Comment_commentInfo__qK+dd","commentReply":"Comment_commentReply__7Rp47","replyToggle":"Comment_replyToggle__2XojV"};